import { Component, OnInit } from '@angular/core';
import { faSearch, faPencilAlt, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { BankService } from 'src/app/shared/services/admin-services/bank.service';
import { Bank } from 'src/app/shared/models/admin-models/bank.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Filter } from 'src/app/shared/models/filter.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-banks',
  templateUrl: './banks.component.html',
  styleUrls: ['./banks.component.sass']
})
export class BanksComponent implements OnInit {
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;
  faCheck = faCheck;
  faTimes = faTimes;

  filter: Filter = new Filter({ Top: null, Page: null, Filter: { Name: '' }, Sort: {} })
  bankArray: Observable<Bank[]>;
  addOrEditBool: Boolean = true;
  bankId: Number;

  filterForm = new FormGroup({
    name: new FormControl('', [])
  })

  bankForm = new FormGroup({
    code: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    swiftCode: new FormControl('', [Validators.required]),
    platimatik: new FormControl(true, [])
  })

  constructor(private bankService: BankService, private modalService: NgbModal) { }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.filter.data.Filter = {}

    if (this.filterForm.value.name)
      this.filter.data.Filter.Name = this.filterForm.value.name;


    this.bankArray = this.bankService.gridView(this.filter)
    // this.bankService.gridView(new Filter({ Top: this.top, Page: this.page, Filter: {}, Sort: {} }))
    //   .subscribe(
    //     (res) => {
    //       console.log(res)
    //     },
    //     (error) => {
    //       console.log(error)
    //     }
    //   )
  }

  openAddBankModal(modal) {
    this.addOrEditBool = true;
    this.bankForm.reset({ platimatik: true })
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  addBank() {
    let bank = new Bank({ Name: this.bankForm.value.name, Code: this.bankForm.value.code, SwiftCode: this.bankForm.value.swiftCode, Platimatik: this.bankForm.value.platimatik })
    this.bankService.createBank(bank).then(
      x => {
        this.getAll();
        this.modalService.dismissAll();
      },
      (reject) => {
        console.log(reject);
      }
    );
  }

  openEditModal(modal, id) {
    this.addOrEditBool = false;
    this.bankService.getOne(id).then(
      (r: { id: Number, name: String, code: String, swiftCode: String, platimatik: Boolean }) => {
        this.bankId = r.id;
        this.bankForm.get('code').setValue(r.code);
        this.bankForm.get('name').setValue(r.name);
        this.bankForm.get('swiftCode').setValue(r.swiftCode);
        this.bankForm.get('platimatik').setValue(r.platimatik);
        this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
      }
    );
  }
  editBank() {
    let bank = new Bank({ Id: this.bankId, Name: this.bankForm.value.name, Code: this.bankForm.value.code, SwiftCode: this.bankForm.value.swiftCode, Platimatik: this.bankForm.value.platimatik })
    this.bankService.editBank(bank).then(
      x => {
        this.getAll();
        this.modalService.dismissAll()
      }
    );
  }

  openDeleteModal(modal, id) {
    this.bankId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }
  deleteBank() {
    this.bankService.deleteBank([this.bankId])
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll()
        }
      );
  }

  clearFilters() {
    this.filterForm.reset({ name: '' })
    this.getAll();
  }

}
